import { render, staticRenderFns } from "./TaskRewardDetail.vue?vue&type=template&id=19fd90a3&"
import script from "./TaskRewardDetail.vue?vue&type=script&lang=js&"
export * from "./TaskRewardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports